export default {
  no_browser: "No browser found",
  browser_required:
    "This app needs an internet browser in order to work. Make sure you have one installed. For example: Google Chrome, Mozilla Firefox, Microsoft Edge, or Samsung Internet.",
  different_profiles:
    "If your device uses a setup with a personal profile and a work profile, make sure the browser is installed to the same profile as SAMMY.",
  not_disabled: "Lastly, make sure that the browser application is not disabled.",
  problem_persists: "If the problem persists, please contact {url}",

  unsupported_browser: "Unsupported browser",
  outdated_browser: "Your browser is either outdated or not fully supported",
  app_not_work: "We cannot guarantee that the app is going to work properly.",
  update_browser: "We recommend that you try to update or use one of the browsers we support.",
  supported_browsers:
    "Supported browsers include: Google Chrome, Mozilla Firefox, Microsoft Edge, or Samsung Internet.",
  dont_show_again: "Don't show this page again.",
}
